import React from "react";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { WHY_CHOOSE, PROCESS } from "@/constants/content";

export function WhyChoose() {
  return (
    <section id="why" className="section bg-white" data-testid="why-section">
      <div className="container-page">
        <div className="max-w-2xl">
          <div className="eyebrow mb-3">Why Choose KinFlex</div>
          <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Healthcare that <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">feels like family</span>.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Heart;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.35, delay: (i % 3) * 0.06 }}
                className="rounded-2xl bg-white border border-slate-200/70 p-6 hover:border-[#0A84FF]/30 hover:shadow-lg transition-all group"
                data-testid={`why-card-${i}`}
              >
                <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#0A84FF] to-[#10B981] flex items-center justify-center text-white group-hover:scale-110 transition-transform">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-display font-semibold text-slate-900 text-lg">{w.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{w.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function ProcessSection() {
  return (
    <section className="section bg-[#F8FAFC]" data-testid="process-section">
      <div className="container-page">
        <div className="text-center max-w-2xl mx-auto">
          <div className="eyebrow mb-3 justify-center">How It Works</div>
          <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Simple, fast, and fully supported.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-4 gap-6 md:gap-8 relative">
          <div className="hidden md:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-[#0A84FF]/30 via-[#10B981]/30 to-[#0A84FF]/30" />
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="relative text-center md:text-left"
              data-testid={`process-step-${i}`}
            >
              <div className="mx-auto md:mx-0 h-16 w-16 rounded-2xl bg-white border-2 flex items-center justify-center font-display font-bold text-xl shadow-md relative z-10" style={{ borderColor: '#0A84FF', color: '#0A84FF' }}>
                {p.step}
              </div>
              <h3 className="mt-5 font-display font-semibold text-slate-900 text-xl">{p.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
